import { useEffect, useRef } from "react";

interface UseRestoreFocusOptions {
    active: boolean;
}
export const useRestoreFocusOnClose = ({active}: UseRestoreFocusOptions) => {
    const prevActiveElementRef = useRef<HTMLElement | null>(null);
    
    useEffect(() => {
        if (active && !prevActiveElementRef.current) {
            prevActiveElementRef.current = document.activeElement as HTMLElement;
        }
    }, [active])

    const restoreFocus = () => {
        const activeElement = document.querySelector('.poi-active') as HTMLElement;
        if (activeElement) {
            activeElement.focus({ preventScroll: false });
            activeElement.classList.remove('poi-active');
        } else if (prevActiveElementRef.current) {
            const elementToRestore = prevActiveElementRef.current;
            prevActiveElementRef.current = null;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (document.body.contains(elementToRestore) && elementToRestore.focus) {
                        try {
                            elementToRestore.focus({ preventScroll: false });
                        } catch (error) {
                        }
                    }
                });
            });
        }
    }

    return {restoreFocus}
} 